export { ClickableArea } from './ClickableArea';
